import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-googlecast',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Google Cast icon</title><path d="M0 18.5455v3.2727h3.2727c0-1.811-1.4618-3.2727-3.2727-3.2727zm0-4.3637v2.1818c3.011 0 5.4545 2.4437 5.4545 5.4546h2.1819c0-4.2218-3.4146-7.6364-7.6364-7.6364zm0-4.3636V12c5.4218 0 9.8182 4.3964 9.8182 9.8182H12c0-6.6327-5.3782-12-12-12zm21.8182-7.6364H2.1818C.9818 2.1818 0 3.1636 0 4.3636v3.2728h2.1818V4.3636h19.6364v15.2728h-7.6364v2.1818h7.6364c1.2 0 2.1818-.9818 2.1818-2.1818V4.3636c0-1.2-.9818-2.1818-2.1818-2.1818Z"/></svg>`,
    styles: []
})
export class SimpleIconsGooglecastComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#1BB6F6';
    @Input() className: string = 'simple-icons-googlecast'
    constructor() {}
    ngOnInit(): void {}
}
